import React from 'react';
import { SelectLabel } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function StatusSelect({ form, setStatus }) {
    const { t } = useTranslation();

    const handleStatus = React.useCallback(value => {
        setStatus({ ...form, status: value, reservation: value === 'valid' ? 0 : 1, statusColor: value === 'valid' ? 'green' : 'orange' });
    });

    const options = [
        { text: t('attendees.addAttendees.paymentStatusPaid'), value: 'valid' },
        { text: t('attendees.addAttendees.paymentStatusBooked'), value: 'reservation' }
    ];

    return <SelectLabel label={t('attendees.addAttendees.paymentStatus')} value={form?.status} options={options} onChange={value => handleStatus(value)} />;
}
